import { makeObservable, observable, action } from 'mobx';

var NotificationStore = /** @class */ (function () {
    function NotificationStore() {
        this.notificationCode = null;
        this.operatorErrorMessage = null;
        this.notTimerId = null;
        makeObservable(this, {
            notificationCode: observable,
            operatorErrorMessage: observable,
            notTimerId: observable,
            setNotificationType: action.bound,
            resetNotificationType: action.bound,
            clearNotificationTimerId: action.bound,
            setOperatorErrorMessage: action.bound,
            resetOperatorErrorMessage: action.bound,
        });
    }
    NotificationStore.prototype.clearNotificationTimerId = function () {
        if (this.notTimerId) {
            clearTimeout(this.notTimerId);
            this.notTimerId = null;
        }
    };
    NotificationStore.prototype.setNotificationType = function (type) {
        this.notificationCode = type;
    };
    NotificationStore.prototype.resetNotificationType = function () {
        this.notificationCode = null;
    };
    NotificationStore.prototype.setOperatorErrorMessage = function (errorMessage) {
        var _this = this;
        this.operatorErrorMessage = errorMessage;
        setTimeout(function () {
            _this.resetOperatorErrorMessage();
        }, 2000);
    };
    NotificationStore.prototype.resetOperatorErrorMessage = function () {
        this.operatorErrorMessage = null;
    };
    return NotificationStore;
}());
var notificationStore = new NotificationStore();

export { NotificationStore, notificationStore };
